// Backend stores hover HTML in `text`. Plotly v2 draws `text` on bars
// unless textposition is none. Move it to hover and hide bar labels.
export function normalizeBarTooltips(traces) {
  if (!Array.isArray(traces)) return traces;
  traces.forEach(trace => {
    if (!trace) return;
    const type = String(trace.type || '').toLowerCase();
    const isBar =
      type === 'bar' ||
      type === 'histogram' ||
      type === 'waterfall' ||
      (!type && (trace.orientation === 'h' || trace.orientation === 'v'));
    if (!isBar) return;

    if (typeof trace.text === 'undefined' || trace.text === null) {
      if (trace.textposition == null) {
        trace.textposition = 'none';
      }
      return;
    }

    trace.customdata = trace.text;
    delete trace.hoverinfo;
    trace.hovertemplate = '%{customdata}<extra></extra>';
    trace.textposition = 'none';
    delete trace.texttemplate;
    delete trace.hovertext;
    delete trace.text;
  });
  return traces;
}
